import React from 'react';
import ClassNames from 'classnames';
import { EmptyDataList } from '../../ui-widgets';

import './outer-list-layout.scss';

interface OuterListLayoutProps {
    showIsEmpty: boolean;
}

export const OuterListLayout: React.FC<OuterListLayoutProps> = ({ showIsEmpty, children }): React.ReactElement => {
    const contentClassnames = ClassNames('outer-list-layout__content', {
        'outer-list-layout__content--is-empty': showIsEmpty,
    });

    return (
        <div className="outer-list-layout">
            <div className={contentClassnames}>{children}</div>
            {showIsEmpty && <EmptyDataList />}
        </div>
    );
};
